module.exports = __webpack_public_path__ + "img/w-2.919f0ddb.png";